<template>
    <div
        ref="scrollList"
        :style="{ backgroundColor: colors.messageList.bg }"
        class="sc-message-list"
        @scroll="handleScroll"
    >
        <Message
            v-for="(message, idx) in messages"
            :id="message.id ? message.id : idx"
            :key="idx"
            :colors="colors"
            :is-chat-window="ischatwindow"
            :is-colored="isColored"
            :message="message"
            :random-bg-color-with-name="randomBgColorWithName"
            :showAvatar="showAvatar"
            :user="profile(message.author)"
            @remove="$emit('remove', message)"
            :disable-translation="disableTranslation"
        >
            <template v-slot:user-avatar="scopedProps">
                <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
            </template>
            <template v-slot:text-message-body="scopedProps">
                <slot
                    :me="scopedProps.me"
                    :message="scopedProps.message"
                    :messageColors="scopedProps.messageColors"
                    :messageText="scopedProps.messageText"
                    name="text-message-body"
                >
                </slot>
            </template>
            <template v-slot:text-message-toolbox="scopedProps">
                <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox"></slot>
            </template>
        </Message>
        <div v-if="newMsg && ischatwindow" class="newMsg" @click="_scrollDown">
            <md-icon>expand_more</md-icon>
        </div>
    </div>
</template>

<script>
import { socketMessageStream } from "../../utils/socketStream";
import { filter } from "rxjs/operators";
import { mapState } from "vuex";

import Message from "./Message.vue";
import chatIcon from "./assets/chat-icon.svg";

export default {
    components: {
        Message,
    },
    props: {
        disableTranslation: {
            type: Boolean,
            default: false,
            required: false,
        },
        ischatwindow: {
            type: Boolean,
            default: false,
        },
        participants: {
            type: Array,
            required: true,
        },
        messages: {
            type: Array,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },
        scrollTop: {
            type: Boolean,
            required: false,
            default: false,
        },
        showAvatar: {
            type: Boolean,
            required: false,
            default: false,
        },
        randomBgColorWithName: {
            type: Boolean,
            required: false,
            default: false,
        },
        isColored: {
            type: Boolean,
            default: false,
            required: false,
        },
        isPrivateChat: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            newMsg: false,
            isScrolled: false,
            sub: null,
        };
    },
    methods: {
        _scrollDown() {
            console.log("scrollDown", this.$refs.scrollList);
            if (this.$refs.scrollList) {
                this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
                this.newMsg = false;
                this.isScrolled = false;
            }
        },
        handleScroll(e) {
            if (!this.isPrivateChat) {
                if (e.target.scrollTop === 0) {
                    this.$emit("scrollToTop");
                }

                if (
                    !!this.$refs.scrollList &&
                    this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - this.$refs.scrollList.offsetHeight - 100
                ) {
                    this.newMsg = false;
                    this.isScrolled = false;
                } else {
                    this.isScrolled = true;
                    if (!this.newMsg) this.newMsg = true;
                }
            }
        },
        shouldScrollToBottom() {
            console.log("shouldScrollToBottom", {
                isPrivateChat: this.isPrivateChat,
                alwaysScrollToBottom: this.alwaysScrollToBottom,
                scrollList: this.$refs.scrollList,
                scrollTop: this.$refs.scrollList.scrollTop,
                scrollHeight: this.$refs.scrollList.scrollHeight,
                isScrolled: this.isScrolled,
                ischatwindow: this.ischatwindow,
            });
            if (!this.isPrivateChat) {
                return (
                    (this.alwaysScrollToBottom ||
                        (!!this.$refs.scrollList &&
                            this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - this.$refs.scrollList.offsetHeight - 100)) &&
                    (!this.isScrolled || !this.ischatwindow)
                );
            }
        },
        profile(author) {
            const profile = this.participants.find((profile) => profile.id === author);

            // A profile may not be found for system messages or messages by 'me'
            /*return profile || {imageUrl: '', name: ''}*/
            return { imageUrl: "", name: author };
        },
    },
    computed: {
        ...mapState({
            activeConversation: (state) =>
                state.app.fakeMode ? state.chat.fakeActiveConversation : state.chat.activeConversation,
            lastPrivateMessage: (state) => state.app.lastPrivateChat,
            unreadCount: (state) => state.app.unreadPrivateChatCount,
        }),
        defaultChatIcon() {
            return chatIcon;
        },
    },
    mounted() {
        if (!this.scrollTop && !this.isScrolled) {
            this.$nextTick(this._scrollDown());
        }
        this.sub = socketMessageStream
            .pipe(
                filter(
                    (x) =>
                        ["visitor", "user"].includes(x.data.messageType) &&
                        this.activeConversation !== null &&
                        x.data.conversationId === this.activeConversation._id
                )
            )
            .subscribe(() => {
                if (this.isScrolled) this.newMsg = true;
            });
    },
    updated() {
        if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
    },
    beforeDestroy() {
        if (this.sub) this.sub.unsubscribe();
    },
};
</script>

<style lang="scss" scoped>
.sc-message-list {
    height: 100%;
    overflow-y: auto;
    background-size: 100%;
    padding: 40px 12px;

    .newMsg {
        position: absolute;
        bottom: 10px;
        right: 10px;
        z-index: 2;
        padding: 2.5px;
        border-radius: 50%;
        background-color: #ff4e4e;
        box-shadow: 0 0 6px #00000080;
        cursor: pointer;

        .md-icon.md-theme-default.md-icon-font {
            color: #ffffff;
        }
    }
}
</style>
